import { render, staticRenderFns } from "./ProgressionBarSkeleton.vue?vue&type=template&id=6f5546c6&scoped=true&"
import script from "./ProgressionBarSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProgressionBarSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProgressionBarSkeleton.vue?vue&type=style&index=0&id=6f5546c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5546c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VProgressLinear,VSkeletonLoader})
